import React, { useContext } from 'react';
import { LocalizationContext } from '../../context/localizationContext';
import { clubsContext } from '../../context/clubsContext';
import keys from '../../keys.json';
import Add from '../../assets/images/icons/add.svg';
import Styles from './ClubRegistrationTileHeader.module.scss';

const TileHeader = (props) => {
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const { tileText, headerLabel } = localizationState.localization;
  const clubContext = useContext(clubsContext);
  const { state, dispatch } = clubContext;
  const { userClubs } = state;
  const { toggleModal, serviceDown } = props;
  const { linkKeys } = keys;

  const handleRegisterClubClick = () => {
    dispatch({ type: 'SET_LINK_KEY', key: linkKeys?.addClub });
    toggleModal();
  };

  return (
    <div className={Styles.header}>
      <div className={Styles.headerText}>
        {headerLabel?.myClubs}
        {!serviceDown && userClubs?.length ? (
          <button
            className={Styles.smallAddClubtBtn}
            onClick={handleRegisterClubClick}
            type="button"
          >
            <img src={Add} alt="Add New Club" />
          </button>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default TileHeader;
